<div class="modal-header">
  <h4 class="modal-title">Bulk Upload Members</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>
    To bulk upload association members,
    <a href="#" (click)="downloadTemplate(); $event.preventDefault();">download this spreadsheet template</a>
    and add a row for each member.
  </p>

  <p>
    Enter each member's birthday in the format <b>YYYY-MM-DD</b> (for example, 2010-06-05).
  </p>

  <p>
    If an association member does not have a customer account in Capitan, one will be created for them. If they already have a Capitan account with an associated email address <b>they will keep their Capitan email address, and the email address in the spreadsheet will not be used</b>.
  </p>

  <hr>

  <div class="form-group">
    <label for="customersInput">Members CSV File</label>
    <input type="file" class="form-control-file" id="customersInput"
           name="customersInput"
           [disabled]="isLoading()"
           [class.disabled]="isLoading()"
           (change)="onFileSelected($event)">
  </div>

  <div class="alert alert-info mb-0"
       *ngIf="!isLoading() && (membersToUpload.length > 0) && !validationErrorMessage">
    {{ membersToUpload.length }} association members will be uploaded. Click "Upload" below to proceed.
  </div>

  <div class="alert alert-info mb-0" *ngIf="loadingSubmit">
    {{ numSaved }} / {{ membersToUpload.length }} association members uploaded...
  </div>

  <div class="alert alert-danger mb-0" *ngIf="validationErrorMessage">
    {{ validationErrorMessage }}
  </div>
  <div class="alert alert-danger mb-0" *ngIf="!loadingSubmit && (saveFailures.length > 0)">
    <p class="mb-1">
      {{ numSaved }} of {{ membersToUpload.length }} association members were uploaded.
      These members could not be added:
    </p>
    <ul class="mb-0 pl-4">
      <li *ngFor="let saveFailure of saveFailures | slice:0:maxDisplayedFailures">
        Row {{ saveFailure.rowNumber }} — <b>{{ saveFailure.name }}</b>: {{ saveFailure.message }}
      </li>
    </ul>
    <p class="mb-0 mt-1" *ngIf="saveFailures.length > maxDisplayedFailures">
      ...and {{ saveFailures.length - maxDisplayedFailures }} more.
    </p>
    <p class="mb-0 mt-2">
      Correct these rows and upload the spreadsheet again. Members which uploaded
      successfully will not be added twice.
    </p>
  </div>
  <div class="alert alert-info mb-0" *ngIf="parsingUpload">
    Parsing spreadsheet...
  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-primary"
          (click)="handleSave()"
          [disabled]="!validInputSelected() || isLoading()"
          [class.disabled]="!validInputSelected() || isLoading()">
    {{ loadingSubmit ? 'Loading...' : 'Upload' }}
  </button>
</div>
